import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import logo from "assets/img/brand/logo-buhler-new.svg";

const LANGUAGES = ["de", "en", "it"];

function MenuIcon({ open }) {
  return (
    <svg className="menu-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {open ? (
        <path d="M5 5 L19 19 M19 5 L5 19" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      ) : (
        <path d="M4 7 H20 M4 12 H20 M4 17 H20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      )}
    </svg>
  );
}

function SiteNav() {
  const { t } = useTranslation();
  // Summe direkt im Selector berechnen: der Legacy-Reducer mutiert quantity
  // in-place, die Array-Referenz ändert sich nicht — der Zahlvergleich des
  // Selector-Ergebnisses erkennt die Änderung trotzdem.
  const cartCount = useSelector(state =>
    state.addedItems.reduce((sum, item) => sum + (item.quantity || 0), 0)
  );
  const activeLang = (i18n.language || "de").slice(0, 2).toLowerCase();
  const [menuOpen, setMenuOpen] = React.useState(false);
  const closeMenu = () => setMenuOpen(false);

  React.useEffect(() => {
    document.body.classList.toggle("nav-menu-open", menuOpen);
    return () => document.body.classList.remove("nav-menu-open");
  }, [menuOpen]);

  const links = (
    <>
      <Link to="/" onClick={closeMenu}>{t("nav.Home")}</Link>
      {/* Shop bewusst an zweiter Stelle: Er ist das Hauptangebot, nicht ein
          Unterpunkt zwischen den Inhaltsseiten. */}
      <Link to="/unser-honig" onClick={closeMenu}>{t("nav.Our honey")}</Link>
      <Link to="/fuer-unternehmen" onClick={closeMenu}>{t("nav.For businesses")}</Link>
      <Link to="/ueber-uns" onClick={closeMenu}>{t("nav.About us")}</Link>
      <Link to="/live" onClick={closeMenu}>{t("nav.Live from the hive")}</Link>
      <Link to="/faq" onClick={closeMenu}>{t("nav.FAQ")}</Link>
    </>
  );

  const langToggle = (
    <div className="lang-toggle">
      {LANGUAGES.map((lng, idx) => (
        <React.Fragment key={lng}>
          {idx > 0 && " / "}
          <button
            type="button"
            className={activeLang === lng ? "lang-active" : ""}
            onClick={() => i18n.changeLanguage(lng)}
          >
            {lng.toUpperCase()}
          </button>
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <nav className="rd-nav">
      <div className="nav-inner">
        <Link to="/" className="logo-mark" onClick={closeMenu}>
          <img src={logo} alt="Imkerei Bühler" className="logo-img" />
        </Link>
        <div className="nav-links">{links}</div>
        <div className="nav-right">
          {langToggle}
          <Link
            to="/warenkorb"
            className={"cart-btn" + (cartCount > 0 ? " cart-btn-filled" : "")}
            onClick={closeMenu}
            aria-label={t("nav.Cart") + ": " + cartCount}
          >
            <span className="cart-btn-label">{t("nav.Cart")}</span>
            <span className="cart-badge" aria-hidden="true">{cartCount}</span>
          </Link>
          <button
            type="button"
            className="nav-menu-toggle"
            aria-label={menuOpen ? t("nav.Close menu") : t("nav.Open menu")}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen(open => !open)}
          >
            <MenuIcon open={menuOpen} />
          </button>
        </div>
      </div>
      <div className={"nav-mobile-panel" + (menuOpen ? " nav-mobile-panel-open" : "")}>
        <div className="nav-mobile-links">{links}</div>
        <div className="nav-mobile-lang">{langToggle}</div>
      </div>
    </nav>
  );
}

export default SiteNav;
